module.exports = __webpack_public_path__ + "0cdb6d0699a114bf3fc2e101f5e0f411.svg";